import { ComponentAPI, Value } from '@philips-emr/tws-core';

class SpreaderAPI extends ComponentAPI {

  getData(): Record<string, Value> {
    return this.state.data;
  }

  setData(data: Record<string, Value>): void {
    this.setState({ data });
  }

  getEntries(): string[] {
    return this.state.entries;
  }

  setEntries(entries: string[]): void {
    this.setState({ entries });
  }
}

export default SpreaderAPI;
